export default (theme) => ({
    root: {},
    selectView: {
        marginLeft: '8px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
    },
    selectViewLabel: {
        marginRight: '16px',
    },
    sectionView: {
        marginBottom: '24px',
    },
    deleteView: {
        color: theme.colors.semantic.negative500,
        cursor: 'pointer',
        transition: 'all 0.15s ease',
        '&:hover': {
            color: theme.colors.semantic.negative500,
        },
    },
});
